import { Component, ViewChild, ElementRef, EventEmitter, Output, Input } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { JwtHelper } from 'angular2-jwt';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { Router, ActivatedRoute } from '@angular/router'

//Services
import { PobookService } from "../../../shared/services/pobook.service";

@Component({
  selector: 'app-userlog-popup',
  templateUrl: './userlog-popup.component.html',
  styleUrls: ['./userlog-popup.component.css']
})
export class UserlogPopupComponent {
  @ViewChild('contentLog') modal: ElementRef;
  @Output() onAddedUserEvent: EventEmitter<any> = new EventEmitter();

  @Input() contactID: number;
  @Input() opportunityID: number;

  userlogForm: FormGroup;
  modalRef: NgbModalRef;
  users: any = []
  contacts: any = []
  opportunities: any = []
  typeOptions: any = []
  isSubmitted: boolean = false
  isContactPage: boolean = false
  isOpportunityPage: boolean = false
  idForFilter: number

  constructor(private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private jwtHelper: JwtHelper,
    private pobookService: PobookService,
    private spinner: Ng4LoadingSpinnerService,
    private route: Router,
    private actRoute: ActivatedRoute
  ) { }


  clearForm() {
    this.userlogForm.controls['opportunity'].setValue('')
    this.userlogForm.controls['contact'].setValue('')
    this.isOpportunityPage = false
    this.isContactPage = false
    this.getContacts()
    this.getopportunities()
  }

  filterOpportunities(id) {
    if (this.userlogForm.controls['opportunity'].value == '') {
      this.pobookService.filterOppty(id).subscribe(res => {
        res['data'].map(i => {
          i['value'] = i.oppty_id
          i['label'] = i.oppty_name
        })
        this.opportunities = res['data']
        this.userlogForm.controls['opportunity'].setValue('')
      }, error => {
        console.log(error)
      })
    }
  }

  filterContacts(id) {
    if (this.userlogForm.controls['contact'].value == '') {
      this.pobookService.getAllContacts(id).subscribe(res => {
        res['data'].map(i => {
          i['value'] = i.contact_id
          i['label'] = i.contact_name
        })
        this.contacts = res['data']
        this.userlogForm.controls['contact'].setValue('')
      }, error => {
        console.log(error)
      })
    }
  }

  get f() {
    return this.userlogForm.controls;
  }

  getContacts() {
    this.pobookService.getContactList({ type: 'all' }).subscribe(response => {
      this.contacts = response['data']
      if(this.isContactPage && this.idForFilter){
        this.userlogForm.controls['contact'].setValue(this.idForFilter)
        this.filterOpportunities(this.idForFilter)
      }
    })
  }

  getopportunities() {
    this.pobookService.getOpportunitiesList().subscribe(response => {
      this.opportunities = response['data']
      if(this.isOpportunityPage && this.idForFilter){
        this.userlogForm.controls['opportunity'].setValue(this.idForFilter)
        this.filterContacts(this.idForFilter)
      }
    })
  }

  createForm() {
    this.userlogForm = this.formBuilder.group({
      'user': ['', Validators.required],
      'type': ['', Validators.required],
      'contact': ['', Validators.required],
      'opportunity': [''],
      'message': ['', Validators.required],
      'startTime': ['', Validators.required],
      'endTime': ['', Validators.required]
    });
  }

  showModal() {
    this.isContactPage = this.route.url.indexOf('contacts') > -1
    this.isOpportunityPage = this.route.url.indexOf('opportunities') > -1
    this.idForFilter = parseInt((this.route.url).replace(/[^0-9]/g,''))

    if( (this.isContactPage || this.isOpportunityPage) && this.idForFilter ){
      if(this.isContactPage){
        this.getContacts()
      } else {
        this.getopportunities()
      }
    } else {
      this.getContacts()
      this.getopportunities()
    }
    this.isSubmitted = false
    this.createForm();
    this.typeOptions = [
      { value: 'rendering', name: 'Rendering' },
      { value: 'meet customer', name: 'Meet Customer' },
      { value: 'call with customer', name: 'Call With Customer' },
      { value: 'went to jobsite', name: 'Went To Jobsite' },
      { value: 'personal time', name: 'Personal Time' }
    ]

    this.users = JSON.parse(sessionStorage.getItem('userlist'));
    let user = this.jwtHelper.decodeToken(JSON.parse(sessionStorage.getItem('currentUser')).token)
    this.userlogForm.controls['user'].setValue(user.userId)

    this.modalRef = this.modalService.open(this.modal, { windowClass: 'contact-modal' });
  }

  saveLog() {
    this.isSubmitted = true
    if (this.userlogForm.invalid) return
    this.spinner.show()
    let msg = ''
    if (this.userlogForm.value.opportunity) {
      let opptyIndex = this.opportunities.findIndex(i => i.value == this.userlogForm.value.opportunity)
      msg = `${this.userlogForm.value.message} for opportunity '${this.opportunities[opptyIndex].label}'`
    } else {
      msg = `${this.userlogForm.value.message}`
    }
    let data = {
      'user_id': this.userlogForm.value.user,
      'type': this.userlogForm.value.type,
      'contactId': this.userlogForm.value.contact,
      'newID': this.userlogForm.value.opportunity ? this.userlogForm.value.opportunity : null,
      'message': msg,
      'startTime': this.convertDateToDATETIME(this.userlogForm.value.startTime),
      'endTime': this.convertDateToDATETIME(this.userlogForm.value.endTime),
      'created_at': this.convertDateToDATETIME(new Date())
    }

    this.pobookService.insertManualUserLog(data).subscribe(response => {
      this.onAddedUserEvent.emit('success')
      this.modalRef.close()
      this.spinner.hide()
    }, error => {
      this.spinner.hide()
      console.log(error)
    })
  }

  convertDateToDATETIME(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear(),
      hours = d.getHours(),
      minutes = d.getMinutes(),
      seconds = d.getSeconds();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
  }

  getHours(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12;
    minutes = minutes < 10 ? '0'+minutes : minutes;
    var strTime = hours + ':' + minutes + ' ' + ampm;
    return strTime;  
  }
}



// WEBPACK FOOTER //
// ./src/app/users/modal-popup/userlog-popup/userlog-popup.component.ts